import { Injectable } from '@angular/core';
import { map, BehaviorSubject, Observable } from 'rxjs';

import {
  WalletTypeEnum,
  WalletTransactionType,
  GetWalletTransactionsByAffectedPaginatedGQL,
} from '@sifca-monorepo/widget-generator';

@Injectable({
  providedIn: 'root',
})
export class MobileWalletService {
  private isLast: BehaviorSubject<boolean> = new BehaviorSubject(null);
  private transactionsCount: BehaviorSubject<number> = new BehaviorSubject(0);
  private loadingTransactions: BehaviorSubject<boolean> = new BehaviorSubject(null);
  private transactions: BehaviorSubject<WalletTransactionType[]> = new BehaviorSubject(null);

  pageIndex = 0;
  pageLimit = 12;
  walletType: WalletTypeEnum;

  get transactionsCount$(): Observable<number> {
    return this.transactionsCount.asObservable();
  }

  get loadingTransactions$(): Observable<boolean> {
    return this.loadingTransactions.asObservable();
  }

  get transactions$(): Observable<WalletTransactionType[]> {
    return this.transactions.asObservable();
  }
  set transactions$(value: any) {
    this.transactions.next(value);
  }

  get isLast$(): Observable<boolean> {
    return this.isLast.asObservable();
  }

  constructor(
    private getWalletTransactionsByAffectedPaginatedGQL: GetWalletTransactionsByAffectedPaginatedGQL,
  ) {}

  getWalletTransactionsByAffectedPaginated(reset = true): Observable<WalletTransactionType[]> {
    if (reset) {
      this.loadingTransactions.next(true);
    }
    return this.getWalletTransactionsByAffectedPaginatedGQL
    .fetch({
      pagination: { page: this.pageIndex, limit: this.pageLimit },
      filter: {
        ...(this.walletType ? { walletType: [this.walletType] } : { walletType: [WalletTypeEnum.QUANTITATIVE] }),
        affected: [{ user: localStorage.getItem('elevkusr') }],
      },
    })
    .pipe(
      map(({ data }: any) => {
        this.loadingTransactions.next(false);
        this.transactionsCount.next(data.getWalletTransactionsByAffectedPaginated.count);
        this.isLast.next(data.getWalletTransactionsByAffectedPaginated.isLast);
        this.transactions.next(data.getWalletTransactionsByAffectedPaginated.objects);
        return data.getWalletTransactionsByAffectedPaginated.objects;
      }),
    );
  }
}
